/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HandPrior
 */
export interface HandPrior {
    /**
     * 
     */
    sex: HandPriorSexEnum;
    /**
     * 
     */
    lengthMmP5: number;
    /**
     * 
     */
    lengthMmP50: number;
    /**
     * 
     */
    lengthMmP95: number;
    /**
     * 
     */
    breadthMmP5: number;
    /**
     * 
     */
    breadthMmP50: number;
    /**
     * 
     */
    breadthMmP95: number;
}


/**
 * @export
 */
export const HandPriorSexEnum = {
    Male: 'male',
    Female: 'female',
} as const;
export type HandPriorSexEnum = typeof HandPriorSexEnum[keyof typeof HandPriorSexEnum];


/**
 * Check if a given object implements the HandPrior interface.
 */
export function instanceOfHandPrior(value: object): value is HandPrior {
    if (!('sex' in value) || value['sex'] === undefined) return false;
    if ((!('lengthMmP5' in (value as Record<string, any>)) && !('length_mm_p5' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMmP5'] === undefined && (value as Record<string, any>)['length_mm_p5'] === undefined)) return false;
    if ((!('lengthMmP50' in (value as Record<string, any>)) && !('length_mm_p50' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMmP50'] === undefined && (value as Record<string, any>)['length_mm_p50'] === undefined)) return false;
    if ((!('lengthMmP95' in (value as Record<string, any>)) && !('length_mm_p95' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMmP95'] === undefined && (value as Record<string, any>)['length_mm_p95'] === undefined)) return false;
    if ((!('breadthMmP5' in (value as Record<string, any>)) && !('breadth_mm_p5' in (value as Record<string, any>))) || ((value as Record<string, any>)['breadthMmP5'] === undefined && (value as Record<string, any>)['breadth_mm_p5'] === undefined)) return false;
    if ((!('breadthMmP50' in (value as Record<string, any>)) && !('breadth_mm_p50' in (value as Record<string, any>))) || ((value as Record<string, any>)['breadthMmP50'] === undefined && (value as Record<string, any>)['breadth_mm_p50'] === undefined)) return false;
    if ((!('breadthMmP95' in (value as Record<string, any>)) && !('breadth_mm_p95' in (value as Record<string, any>))) || ((value as Record<string, any>)['breadthMmP95'] === undefined && (value as Record<string, any>)['breadth_mm_p95'] === undefined)) return false;
    return true;
}

export function HandPriorFromJSON(json: any): HandPrior {
    return HandPriorFromJSONTyped(json, false);
}

export function HandPriorFromJSONTyped(json: any, ignoreDiscriminator: boolean): HandPrior {
    if (json == null) {
        return json;
    }
    return {
        
        'sex': json['sex'],
        'lengthMmP5': json['length_mm_p5'],
        'lengthMmP50': json['length_mm_p50'],
        'lengthMmP95': json['length_mm_p95'],
        'breadthMmP5': json['breadth_mm_p5'],
        'breadthMmP50': json['breadth_mm_p50'],
        'breadthMmP95': json['breadth_mm_p95'],
    };
}

export function HandPriorToJSON(json: any): HandPrior {
    return HandPriorToJSONTyped(json, false);
}

export function HandPriorToJSONTyped(value?: HandPrior | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sex': value['sex'],
        'length_mm_p5': value['lengthMmP5'],
        'length_mm_p50': value['lengthMmP50'],
        'length_mm_p95': value['lengthMmP95'],
        'breadth_mm_p5': value['breadthMmP5'],
        'breadth_mm_p50': value['breadthMmP50'],
        'breadth_mm_p95': value['breadthMmP95'],
    };
}

